import React from 'react';
import ReactContentLoader, { IContentLoaderProps } from 'react-content-loader';

export interface ContentLoaderProps extends IContentLoaderProps {}

const ContentLoader: React.FC<ContentLoaderProps> = ({ height = 600, width = 1280, ...rest }) => (
  <ReactContentLoader speed={2} width={width} height={height} {...rest} />
);

export default ContentLoader;
